export const prepareValuesFromProps = (value, maximumValue, minimumValue) => {
    const normalized = [];
    let arrayValue = value;
    if (!Array.isArray(value)) {
        arrayValue = [value];
    }
    for (let i = 0; i < arrayValue.length; i++) {
        let newValue = arrayValue[i];
        if (typeof newValue !== 'number') {
            newValue = i > 0 ? normalized[i - 1] : 0;
        }
        newValue = Math.max(Math.min(newValue, maximumValue), minimumValue);
        normalized.push(newValue);
    }
    return normalized;
};
